import React from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const AcademicEvent = () => {
  const eventList = [
    {
      itemCode: "EVT001",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT002",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT003",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT004",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT005",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT006",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT007",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
    {
      itemCode: "EVT008",
      event: "Women safety awareness campaign",
      time: "10:30 PM",
      date: "18 Oct, 2025",
      mode: "Online",
      organizer: "School authority",
    },
  ];

  const eventTableHeaders = [
    { key: "event", label: "Events" },
    { key: "time", label: "Date & time" },
    { key: "mode", label: "Online/Offline" },
    { key: "organizer", label: "Organized by" },
  ];

  const eventHistoryData = [
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Women safety awareness campaign",
      items: [
        { item: "Pandal", quantity: "10 pcs", amount: 18000 },
        { item: "Flower", quantity: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Women safety awareness campaign",
      items: [
        { item: "Pandal", quantity: "10 pcs", amount: 18000 },
        { item: "Flower", quantity: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Women safety awareness campaign",
      items: [
        { item: "Pandal", quantity: "10 pcs", amount: 18000 },
        { item: "Flower", quantity: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Women safety awareness campaign",
      items: [
        { item: "Pandal", quantity: "10 pcs", amount: 18000 },
        { item: "Flower", quantity: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
    {
      date: "27 Dec, 2024",
      time: "10:24 AM",
      receiptId: "23457289056",
      event: "Women safety awareness campaign",
      items: [
        { item: "Pandal", quantity: "10 pcs", amount: 18000 },
        { item: "Flower", quantity: "10 pcs", amount: 18000 },
      ],
      totalAmount: 36000,
      paidAmount: 18000,
      paymentMethod: null,
      vendor: {
        name: "Mahi Enterprise",
        phone: "9876543210",
      },
      confirmedBy: "Jaheer Ahmad",
    },
  ];

  const columns = [
    {
      label: "Receipt id/Time",
      key: "receiptId",
      render: (row) => (
        <>
          {row.receiptId}
          <br />
          <span style={{ color: "var(--orangeColor)", fontSize: "small" }}>
            {row.time}
          </span>
        </>
      ),
    },
    {
      label: "Event name",
      key: "eventName",
      render: (row) => <>{row.event}</>,
    },

    {
      label: "Order details",
      key: "orderDetails",
      render: (row) =>
        row.items.map((item, i) => (
          <div key={i}>{item.item + " (" + item.quantity+")"}</div>
        )),
    },
    {
      label: "Amount (INR)",
      key: "amount",
      render: (row) => (
        <>
          {row.items.map((item, i) => (
            <div key={i}>₹ {Number(item.amount).toLocaleString("en-IN")}</div>
          ))}
          <div style={{ borderTop: "1px solid black", marginTop: "4px" }}>
            Total:{" "}
            <span style={{ color: "var(--blueColor1)" }}>
              ₹ {Number(row.totalAmount).toLocaleString("en-IN")}
            </span>
          </div>
        </>
      ),
    },
    {
      label: "Paid amount (INR)",
      key: "paidAmount",
      render: (row) => (
        <>
          ₹ {Number(row.paidAmount).toLocaleString("en-IN")}
          <br />
          <span style={{ color: "var(--deepGreen3)", fontSize: "small" }}>
            {row.paymentMethod}
          </span>
        </>
      ),
    },
    {
      label: "Vendor details",
      key: "vendor",
      render: (row) => (
        <>
          {row.vendor.name}
          <br />
          Ph:{" "}
          <span style={{ color: "var(--blueColor1)" }}>{row.vendor.phone}</span>
        </>
      ),
    },
    {
      label: "Confirmed by",
      key: "confirmedBy",
      render: (row) => (
        <span style={{ color: "var(--deepGreen3)" }}>{row.confirmedBy}</span>
      ),
    },
    {
      label: "Receipts",
      key: "receipts",
      render: (row) => (
        <>
          <span
            style={{
              color: "var(--blueColor1)",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              cursor: "pointer",
            }}
          >
            Receipt <BsBoxArrowRight />
          </span>
          <br />
          <button
            className="action-pay-btn"
            style={{
              backgroundColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
              borderColor:
                row.paidAmount < row.totalAmount
                  ? "var(--tableColor)"
                  : "var(--deepGreen3)",
            }}
          >
            {row.paidAmount < row.totalAmount ? "Pay due" : "All paid"}
          </button>
        </>
      ),
    },
  ];

  // Sample dropdown data
  const confirmedByOptions = ["Admin", "Finance Head", "CEO"];
  const paymentModes = ["Cash", "UPI", "Bank Transfer", "Cheque"];
  const _this = {
    eventList,
    eventTableHeaders,
    eventHistoryData,
    columns,
    confirmedByOptions,
    paymentModes,
  };
  return <Body {..._this} />;
};

export default AcademicEvent;
